import { atom } from 'recoil'
import { ServiceOrderDetailModel } from '@/domain/models'

type ServiceOrderDetailProps = ServiceOrderDetailModel & {
  isLoading: boolean
}

export const serviceOrderDetailState = atom<ServiceOrderDetailProps>({
  key: 'serviceOrderDetail',
  default: {
    ...null as unknown as ServiceOrderDetailModel,
    isLoading: false
  }
})
